/** Vendor admin grids (orgs + users) — FE column key → API sort_by. */

import { pickTabSortParams, sortConfigToApiParams as mapSortConfig } from "./gridSortApiParams";

export const VENDOR_ADMIN_USE_SERVER_SORT = true;

export const VENDOR_ORG_API_SORT_FIELD = {
  name: "name",
  primary_location: "primary_location",
  provider_service_type: "provider_service_type",
  is_active: "is_active",
  discovery_status: "discovery_status",
  portal_access: "portal_access",
  users_count: "users_count",
  requests_count: "requests_count",
  created: "created_at",
};

export const VENDOR_USER_API_SORT_FIELD = {
  name: "name",
  provider_name: "provider_name",
  title: "title",
  email: "email",
  is_active: "is_active",
  role: "role",
  portal_access: "portal_access",
  created_at: "created_at",
};

export function sortConfigToVendorOrgApiParams(sortConfig, enabled = VENDOR_ADMIN_USE_SERVER_SORT) {
  return mapSortConfig(sortConfig, VENDOR_ORG_API_SORT_FIELD, enabled);
}

export function sortConfigToVendorUserApiParams(sortConfig, enabled = VENDOR_ADMIN_USE_SERVER_SORT) {
  return mapSortConfig(sortConfig, VENDOR_USER_API_SORT_FIELD, enabled);
}

export function resolveVendorAdminTabSortParams(activeTab, sortConfig) {
  const orgSortParams =
    activeTab === "organizations" ? sortConfigToVendorOrgApiParams(sortConfig) : undefined;
  const userSortParams =
    activeTab === "users" ? sortConfigToVendorUserApiParams(sortConfig) : undefined;
  return {
    orgSortParams,
    userSortParams,
    serverSortParams: pickTabSortParams(activeTab, orgSortParams, userSortParams),
  };
}
